/* jshint esnext: true */
import { APP_NAME } from '../utils/environment';
import AbstractModule from './AbstractModule';
import { $window, $document } from '../utils/environment';

const MODULE_NAME = 'Checkout';
const EVENT_NAMESPACE = `${APP_NAME}.${MODULE_NAME}`;

const EVENT = {
    CLICK: `click.${EVENT_NAMESPACE}`,
    PRICE_CHANGED: `price_changed.${EVENT_NAMESPACE}`
};


// Trigger `price_changed` on the document like this:
// $(document).trigger('price_changed', [5000]);
// Note that the price is in CENT (basicly price*100)
//
// Provide feedbacks:
// paymentSuccessfull() // Go to next step
// paymentFailure() // Feedback to client whats wrong
//
export default class extends AbstractModule {
    constructor(options) {
        super(options);

        // Private vars.
        this._price; // Total including taxes if any.

        // Regular vars
        this.apiKey = options.key;
        this.paymentAction = options.paymentUrl || 'payment';
        this.stripeInstance;
    }

    /**
     * Init module
     * @return {thisArg} Chainable.
     */
    init() {
        if (typeof StripeCheckout === 'undefined') {
            this.loadCheckoutScript();
             // End it here for now.
            return this;
        }

        this.setEventListeners();

        return this;
    }

    /**
     * Loads the script from stripe.com
     * @return {thisArg} Chainable.
     */
    loadCheckoutScript() {
        $.getScript('https://js.stripe.com/v3/', (response) => {
            this.init();
        });

        return this;
    }

    /**
     * Set all even listeners
     * @return {thisArg} Chainable.
     */
    setEventListeners() {
        this.$el.on(EVENT.CLICK, (e) => {
            let $this = $(e.currentTarget);
            this.checkout();
        });

        $document.on(EVENT.PRICE_CHANGED, (e, price) => {
            this.setPrice(price);
        });


        return this;
    }

    /**
     * Setup stripe handle
     * @return {thisArg} Chainable.
     */
    initStripe() {
        if (this.stripeInstance) {
            return this;
        }

        let that = this;
        // https://stripe.com/docs/checkout#integration-custom
        this.stripeInstance = StripeCheckout.configure({
            key: this.apiKey,
            image: 'https://stripe.com/img/documentation/checkout/marketplace.png',
            locale: 'auto',
            token: (token) => {
                // You can access the token ID with `token.id`.
                // Get the token ID to your server-side code for use.
                let tokenId = token.id; // Required for server side

                $.post('payment', {
                    amount: this.price(),
                    tokenId: tokenId,
                    description: ''
                }, (response) => {
                    if (response.true) {
                        this.paymentSuccessfull(response);
                    } else {
                        this.paymentFailure(response);
                    }
                }, 'json')
            }
        });

        return this;
    }

    /**
     * Actual checkout
     * @return {thisArg} Chainable.
     */
    checkout() {
        let price = this.price();
        if (!price || price < 1) {
            this.invalidCheckout('Invalid price');
            return this;
        }

        if (!this.stripeInstance) {
            this.initStripe();
        }
        this.stripeInstance.open({
            name: 'The English Bus',
            description: 'Achat',
            currency: 'gbp',
            amount: this.price()
        });

        return this;
    }

    /**
     * Whenever an invalid checkout occurs
     * @param  {mixed} feedback Feedback / Reason for the fail.
     * @return {thisArg} Chainable
     */
    invalidCheckout(feedback) {
        // Provide feedback here
        this.$el.css({
            'border': '1px solid red'
        });

        return this;
    }

    /**
     * Called when payment is confirmed.
     * @param response Server response.
     * @return {thisArg} Chainable.
     */
    paymentSuccessfull(response) {
        // Provide positive feedback
        return this;
    }

    /**
     * Called when payment failed.
     * @param response Server response.
     * @return {thisArg} Chainable.
     */
    paymentFailure(response) {
        // Provide negative feedback
        return this;
    }

    /**
     * Set price
     * @param {integer} price Price.
     * @return {thisArg} Chainable.
     */
    setPrice(price) {
        this._price = parseInt(price);
        return this;
    }

    /**
     * @return {integer} Total price.
     */
    price() {
        return this._price;
    }

    /**
     * Destroy all events, remove everything
     * @return {void}
     */
    destroy() {
        super.destroy();
        if (this.stripeInstance) {
            this.stripeInstance.close();
        }
        this.$el.off(`.${EVENT_NAMESPACE}`);
    }
}
